/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Tab_MentionsInputs */

const en_notifications_tab_mentions = /** @type {(inputs: Notifications_Tab_MentionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mentions`)
};

const pt_br2_notifications_tab_mentions = /** @type {(inputs: Notifications_Tab_MentionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menções`)
};

/**
* | output |
* | --- |
* | "Mentions" |
*
* @param {Notifications_Tab_MentionsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_tab_mentions = /** @type {((inputs?: Notifications_Tab_MentionsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Tab_MentionsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_tab_mentions(inputs)
	return pt_br2_notifications_tab_mentions(inputs)
});